import { useTranslation } from 'react-i18n-lite'
import SectionDivider from 'site/Renderer/components/SectionDivider'
import { useFilterFieldsContext } from '../../../context'
import { EmbeddedWrapper } from '../Section.styles'

export type UseSectionLayoutResult = {
  dividerTitle: string
  isVisible: boolean
  DividerComponent: React.ComponentType<{
    title?: string
    backgroundColor?: string
    isVisible?: boolean
    children?: React.ReactNode
  }>
}

export const useSectionLayout = (): UseSectionLayoutResult => {
  const { t } = useTranslation()
  const { config, form } = useFilterFieldsContext()

  const { embedded = false, displayOptionsForElement } = config
  const { title } = form

  const dividerTitle = `${title ?? ''} | ${t('filter-fields.filters')}`
  const isVisible = !displayOptionsForElement?.hideMainCollapsibleContainer
  const DividerComponent = embedded ? EmbeddedWrapper : SectionDivider

  return {
    dividerTitle,
    isVisible,
    DividerComponent
  }
}
